import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const ButtonContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0d88b7;
  border: 2px solid #0d88b7;
  border-radius: 14px;
  color: white;

  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1.3em;
  width: 100%;
  padding: 13px 0;
  margin: 0 auto;
  text-align: center;
  box-shadow: 3px 5px 10px rgba(0, 0, 0, 0.35);
  outline: none;
  cursor: pointer;

  ${({ secondary }) => secondary && "background-color: white;"}
  ${({ secondary }) => secondary && "color: #3C7BBA;"}
`

const Button = ({ secondary, children, ...props }) => {
  return (
    <ButtonContainer {...props} secondary={secondary}>
      {children}
    </ButtonContainer>
  )
}

Button.propTypes = {
  secondary: PropTypes.bool.isRequired,
  children: PropTypes.string.isRequired,
}

Button.defaultProps = {
  secondary: false,
}

export default Button
